import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import { useTreatmentPlans } from "./hooks/useTreatmentPlans";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "treatmentPlansReport.info.title",
  rows: ["treatmentPlansReport.info.note"],
};

const TreatmentPlans = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useTreatmentPlans(requestParams);

  const tableDataEmpty = !isLoading && !data?.reportData?.length;

  const tableData = useMemo(
    () =>
      data?.reportData.map((data) => ({
        invoiceNumber: data.invoice_number,
        patient: data.client,
        employee: data.employee,
        paymentDate: data.payment_date,
        amount: data.amount,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Treatment Plans"
        selectedClinic={selectedClinic}
        period={period}
        clinics={clinics}
        downloadRoute={HTTP_ENDPOINTS.getTreatmentPlans()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Invoice Number", accessor: "invoiceNumber" },
              { data: "Patient", accessor: "patient" },
              { data: "Employee", accessor: "employee" },
              { data: "Payment Date", accessor: "paymentDate" },
              { data: "Amount", accessor: "amount" },
            ]}
            data={tableData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {tableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default TreatmentPlans;
